import { render } from "./ServiceTeam.vue?vue&type=template&id=2acfc40e&scoped=true"
import script from "./ServiceTeam.vue?vue&type=script&lang=js"
export * from "./ServiceTeam.vue?vue&type=script&lang=js"

import "./ServiceTeam.vue?vue&type=style&index=0&id=2acfc40e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2acfc40e"]])

export default __exports__